import { createActions, createReducer } from 'reduxsauce'

import TipoContratoService from '../servicos/TipoContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaTipoContratoInicio: [],
    buscaTipoContratoSucesso: ['tipoContrato'],
    buscaTipoContratoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaTipoContrato = () => {
    return dispatch => {
        dispatch(Creators.buscaTipoContratoInicio())
        let serv = new TipoContratoService()
        return serv
            .getTipoContrato()
            .then(response => dispatch(Creators.buscaTipoContratoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaTipoContratoErro(error)))
    }
}

const buscaTipoContratoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaTipoContratoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaTipoContratoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.tipoContrato, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_TIPO_CONTRATO_INICIO]: buscaTipoContratoInicio,
    [Types.BUSCA_TIPO_CONTRATO_ERRO]: buscaTipoContratoErro,
    [Types.BUSCA_TIPO_CONTRATO_SUCESSO]: buscaTipoContratoSucesso,
})
